(function() {
  if (!window.IntersectionObserver) return;

  function initInfiniteScroll(fc) {
    if (fc._infObs) {
      fc._infObs.disconnect();
      fc._infObs = null;
    }

    var section = fc.closest('.shopify-section');
    if (!section) return;

    var paginationNext = section.querySelector('.pagination__next');
    if (paginationNext) {
      fc.dataset.infinite = paginationNext.href;
    } else {
      delete fc.dataset.infinite;
    }

    if (!fc.dataset.infinite) return;

    var sentinel = fc.querySelector('[data-infinite-scroll-sentinel]');
    if (!sentinel) return;

    fc._infSentinel = sentinel;
    fc._infObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          loadNextPage(fc);
        }
      });
    }, { rootMargin: '0px 0px 300px 0px' });
    fc._infObs.observe(sentinel);
  }

  function loadNextPage(fc) {
    var url = fc.dataset.infinite;
    if (!url || fc._infLoading) return;
    fc._infLoading = true;

    var sentinel = fc._infSentinel;
    if (sentinel) sentinel.classList.add('loading');

    var fetchUrl = url;
    var sectionId = fc.dataset.filterSectionId;
    if (sectionId) {
      fetchUrl = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'section_id=' + sectionId;
    }

    fetch(fetchUrl)
      .then(function(r) { if (!r.ok) throw Error(); return r.text(); })
      .then(function(html) {
        var tmp = document.createElement('template');
        tmp.innerHTML = html;

        var newGrid = tmp.content.querySelector('.filters-adjacent .product-grid');
        var newFc = tmp.content.querySelector('filter-container');
        var oldSentinel = fc.querySelector('[data-infinite-scroll-sentinel]');

        if (newGrid) {
          var curGrid = fc.querySelector('.filters-adjacent .product-grid');
          if (curGrid) curGrid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
        }

        if (newFc && newFc.dataset.infinite) {
          fc.dataset.infinite = newFc.dataset.infinite;
        } else {
          delete fc.dataset.infinite;
        }

        if (!fc.dataset.infinite && oldSentinel) oldSentinel.remove();

        fc._infLoading = false;
        initInfiniteScroll(fc);
      })
      .catch(function() {
        fc._infLoading = false;
        var s = fc._infSentinel;
        if (s) s.classList.remove('loading');
      });
  }

  var reinitTimer;
  function reinitAll() {
    clearTimeout(reinitTimer);
    reinitTimer = setTimeout(function() {
      document.querySelectorAll('filter-container').forEach(initInfiniteScroll);
    }, 100);
  }

  document.addEventListener('DOMContentLoaded', reinitAll);

  var mo = new MutationObserver(reinitAll);
  mo.observe(document.body, { childList: true, subtree: true, attributes: false });
})();
